import { ActionContext, ActionTree, GetterTree } from "vuex";

import { KatashikiParams } from "@/model/KatashikiParams";

// const initialState: KatashikiParams = {
// };
const actions: ActionTree<KatashikiParams, any> = {
  setKatashikiParams(
    { commit }: ActionContext<KatashikiParams, any>,
    payload: KatashikiParams
  ): void {
    commit("setKatashikiParams", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setKatashikiParams(state: KatashikiParams, payload: KatashikiParams) {
    Object.assign(state, payload);
  },
  clearState(state: any) {
    Object.assign(state, { katashikiParams: [] });
  }
};

const getters: GetterTree<KatashikiParams, any> = {
  getKatashikiParams(state: KatashikiParams) {
    return state;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  // state: { ...initialState },
  getters,
  actions,
  mutations
};
